/**
 * Product Bundle JavaScript for new-pdp-v1
 * Handles dynamic pricing, variant selection, and cart functionality
 */


class ProductBundleNewPDPv1 {
  constructor() {
    // Look for our specific template by checking if it has our custom components
    this.container = document.querySelector('.product-single');
    if (!this.container) {
      console.log('ProductBundleNewPDPv1: Container not found'); // Debug log
      return;
    }
    
    // Check if already initialized
    if (this.container.dataset.bundleInitialized === 'true') {
      console.log('ProductBundleNewPDPv1: Already initialized, skipping'); // Debug log
      return;
    }
    
    // Check if this is our custom template by looking for our components
    const hasCustomComponents = this.container.querySelector('.size-selector-new-pdp-v1');
    if (!hasCustomComponents) {
      console.log('ProductBundleNewPDPv1: Not our custom template, skipping'); // Debug log
      return;
    }
    
    console.log('ProductBundleNewPDPv1: Initializing', this.container); // Debug log
    
    // Mark as initialized
    this.container.dataset.bundleInitialized = 'true';

    this.accessoriesSwiper = null;
    this.selectedAccessories = [];

    this.init();
  }

  init() {
    this.bindEvents();
    this.initializeState();
    this.initializeSwipers();
    this.updatePricing();
    this.addSpaceAfterColons();
  }

  initializeSwipers() {

    // Initialize Accessories Swiper
    const accessoriesSwiperEl = this.container.querySelector('[data-accessories-swiper]');
    if (accessoriesSwiperEl) {
      this.accessoriesSwiper = new Swiper(accessoriesSwiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        navigation: {
          nextEl: '.accessories-selector__nav--next',
          prevEl: '.accessories-selector__nav--prev',
        }
      });
    }
  }

  bindEvents() {
    // Size selector events
    this.container.addEventListener('click', (e) => {
      if (e.target.matches('.size-selector__button')) {
        //console.log('Size button clicked:', e.target); // Debug log
        this.handleSizeSelection(e.target);
      }
    });


    // Saucer toggle events
    this.container.addEventListener('click', (e) => {
      if (e.target.matches('.saucer-toggle__option')) {
        this.handleSaucerToggle(e.target);
      }
    });

    // Accessories selector events
    this.container.addEventListener('click', (e) => {
      if (e.target.closest('.accessories-selector__item')) {
        this.handleAccessorySelection(e.target.closest('.accessories-selector__item'));
      }
    });

    // Bundle add to cart
    this.container.addEventListener('click', (e) => {
      if (e.target.matches('[data-bundle-add-to-cart-btn]')) {
        this.handleAddToCart(e);
      }
    });

    // Slider navigation
    this.container.addEventListener('click', (e) => {
      if (e.target.matches('[data-accessories-nav-prev]')) {
        this.navigateSlider('accessories', 'prev');
      }
      if (e.target.matches('[data-accessories-nav-next]')) {
        this.navigateSlider('accessories', 'next');
      }
    });

    // Listen for variant changes from existing theme
    document.addEventListener('variant:change', (e) => {
      this.handleVariantChange(e.detail.variant);
    });

    // Listen for variant price changes from theme's Product class
    this.container.addEventListener('variantPriceChange', (e) => {
      if (e.detail && e.detail.variant) {
        this.updateStandardPriceBlock(e.detail.variant);
      }
    });
  }

  initializeState() {
    // Get current variant from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      // Find the variant data
      const productVariants = JSON.parse(this.container.dataset.productVariants);
      const currentVariant = productVariants.find(variant => variant.id.toString() === variantId);
      
      if (currentVariant) {
        // Update size selector UI based on current variant
        this.updateSizeSelectorFromVariant(currentVariant);
        
        // Update size label
        this.updateSizeLabelFromVariant(currentVariant);
      }
    } else {
      // Fallback to default behavior
      this.currentSize = this.getCurrentSize();
      this.updateSizeLabel();
    }
    

    // Initialize accessories
    this.selectedAccessories = ['none']; // Start with "no accessory"
    this.updateAccessoriesDisplay();

    // Initialize pricing
    this.updatePricing();
  }

  updateSizeSelectorFromVariant(variant) {
    // Clear all size button selections
    this.container.querySelectorAll('.size-selector__button').forEach(btn => {
      btn.classList.remove('size-selector__button--selected');
    });
    
    // Find and select the button that matches this variant
    const sizeButtons = this.container.querySelectorAll('[data-size-value]');
    sizeButtons.forEach(button => {
      if (button.dataset.sizeValue === variant.options[0]) {
        button.classList.add('size-selector__button--selected');
      }
    });
  }

  updateSizeLabelFromVariant(variant) {
    const sizeLabel = this.container.querySelector('[data-current-size-label]');
    if (sizeLabel && variant.options[0]) {
      // Extract last 4 characters (e.g., "25cm" from "S - 25cm")
      const numericalValue = variant.options[0].slice(-5);
      sizeLabel.textContent = `– ${numericalValue}`;
    }
  }

  getCurrentSize() {
    const sizeButtons = this.container.querySelectorAll('[data-size-value]');
    for (let button of sizeButtons) {
      if (button.classList.contains('size-selector__button--selected')) {
        return button.dataset.sizeValue;
      }
    }
    return null;
  }


      handleSizeSelection(button) {
        //console.log('handleSizeSelection called with:', button); // Debug log
        const sizeValue = button.dataset.sizeValue;
        const sizeIndex = parseInt(button.dataset.sizeIndex);
        
        //console.log('Size value:', sizeValue, 'Size index:', sizeIndex); // Debug log
        
        // Update size selector UI
        this.container.querySelectorAll('.size-selector__button').forEach(btn => {
          btn.classList.remove('size-selector__button--selected');
        });
        button.classList.add('size-selector__button--selected');
        
        // Update size label
        const sizeLabel = this.container.querySelector('[data-current-size-label]');
        if (sizeLabel) {
          // Extract last 4 characters (e.g., "25cm" from "S - 25cm")
          const numericalValue = sizeValue.slice(-5);
          sizeLabel.textContent = `– ${numericalValue}`;
        }
        
        // Find the corresponding variant by matching the size value
        const variantInputs = this.container.querySelectorAll('input[data-variant-input]');
        let targetVariantId = null;
        
        // Get all variants from the product data
        const productVariants = JSON.parse(this.container.dataset.productVariants);
        
        // Find the variant that matches the selected size
        const matchingVariant = productVariants.find(variant => {
          return variant.options[0] === sizeValue; // First option is the size
        });
        
        if (matchingVariant) {
          console.log('Found matching variant:', matchingVariant);
          targetVariantId = matchingVariant.id;
          
          // Update the hidden variant input
          variantInputs.forEach(input => {
            input.checked = input.value === targetVariantId.toString();
          });
          
          // Update URL without reloading
          this.updateURL(targetVariantId);
          
          // Trigger theme's variant change event
          this.triggerVariantChange(matchingVariant);
          
          // Update pricing
          this.updatePricing();
          
          // Update standard price block
          this.updateStandardPriceBlock(matchingVariant);
          
          // Reload accessories selector with new variant's metafield data
          this.reloadAccessoriesSelector(matchingVariant);
        } else {
          console.log('No matching variant found for size:', sizeValue);
        }
        setTimeout(function(){
            sj_select_first_item();
            checkAccessoriesAvailability();
            initializePotSaucerSync();
        },300);
        
      }

  updateSizeLabel() {
    const label = this.container.querySelector('[data-current-size-label]');
    if (label && this.currentSize) {
      // Extract last 4 characters (e.g., "25cm" from "S - 25cm")
      const numericalValue = this.currentSize.slice(-5);
      label.textContent = `– ${numericalValue}`;
    }
  }

      triggerVariantChange(variant) {
        // Trigger the theme's variant change event
        const variantChangeEvent = new CustomEvent('variant:change', {
          detail: { variant: variant }
        });
        document.dispatchEvent(variantChangeEvent);
        
        // Also trigger the standard variant change for theme compatibility
        const productSelect = this.container.querySelector('[data-product-select]');
        if (productSelect) {
          productSelect.value = variant.id;
          productSelect.dispatchEvent(new Event('change'));
        }
      }

      updateURL(variantId) {
        if (variantId) {
          const url = new URL(window.location);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url);
        }
      }

  reloadAccessoriesSelector(variant) {
    //console.log('reloadAccessoriesSelector called with variant:', variant);
    
    // Use the AJAX approach to reload accessories selector
    //console.log('Using AJAX approach to reload accessories selector');
    this.reloadAccessoriesSelectorViaAjax(variant.id);
  }


  reloadAccessoriesSelectorViaAjax(variantId) {
  //console.log('Reloading accessories selector via AJAX for variant:', variantId);

  // Build URL with variant
  const currentUrl = new URL(window.location);
  currentUrl.searchParams.set('variant', variantId);

  fetch(currentUrl.toString())
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get ALL updated selectors from AJAX page
      const newSelectors = doc.querySelectorAll('[data-accessories-selector]');

      // Get ALL current selectors on the live page
      const currentSelectors = document.querySelectorAll('[data-accessories-selector]');

      // Loop through each container and replace its contents
      newSelectors.forEach((newSelector, index) => {
        const currentSelector = currentSelectors[index];

        if (!currentSelector) return;

        const newSlider = newSelector.querySelector('.accessories-selector__slider-container');
        const currentSlider = currentSelector.querySelector('.accessories-selector__slider-container');

        if (newSlider && currentSlider) {
          // Replace HTML
          currentSlider.innerHTML = newSlider.innerHTML;

          // Destroy old swiper instance (if exists)
          if (currentSelector.accessoriesSwiper) {
            currentSelector.accessoriesSwiper.destroy(true, true);
          }

          // Re-initialize swiper
          setTimeout(() => {
            const swiperEl = currentSelector.querySelector('[data-accessories-swiper]');

            if (swiperEl) {
              currentSelector.accessoriesSwiper = new Swiper(swiperEl, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                navigation: {
                  nextEl: currentSelector.querySelector('.accessories-selector__nav--next'),
                  prevEl: currentSelector.querySelector('.accessories-selector__nav--prev'),
                }
              });

              currentSelector.accessoriesSwiper.update();
            }
            sj_select_first_item();
            // Disable pot on the basis of saucer
            if (document.querySelector('.sj-kit') && newSelector.classList.contains('sj-saucers')) {
              if(newSelector.querySelectorAll('.accessories-selector__item.disabled')){
                newSelector.querySelectorAll('.accessories-selector__item.disabled').forEach((saucer, index) => {
                  var saucer_color = saucer.dataset.saucerColor;
                  document.querySelector('[data-pot-color="'+saucer_color+'"]').classList.add('disabled'); 
                    console.log(saucer.dataset.saucerColor);

                });
              }
              console.log('.sj-kit exists');
            }
            initializePotSaucerSync();
          }, 120);
        }
      });

      //console.log('All accessories selectors reloaded successfully.');
    })
    .catch(error => {
      console.error('Error reloading accessories selector:', error);
    });
  }
  updateVariantSelection() {
    // Find matching variant based on size
    const variants = JSON.parse(this.container.dataset.productVariants);
    const matchingVariant = variants.find(variant => {
      return variant.options[0] === this.currentSize;
    });

    if (matchingVariant) {
      // Update the hidden select
      const select = this.container.querySelector('[data-product-select]');
      if (select) {
        select.value = matchingVariant.id;
        select.dispatchEvent(new Event('change'));
      }
    }
  }


  updateAccessoriesDisplay() {
    // // Update the accessories count in the title
    // const countElement = this.container.querySelector('[data-accessories-count]');
    // if (countElement && this.selectedAccessories) {
    //   if (this.selectedAccessories.includes('none') || this.selectedAccessories.length === 0) {
    //     countElement.textContent = '(0)';
    //   } else {
    //     const selectedCount = this.selectedAccessories.length;
    //     countElement.textContent = `(${selectedCount})`;
    //   }
    // }
    
    // // Update the accessories list display
    // const list = this.container.querySelector('[data-selected-accessories-list]');
    // if (list) {
    //   list.innerHTML = '';

    //   if (this.selectedAccessories.includes('none')) {
    //     list.innerHTML = '<span class="accessories-selector__selected-item">Aucun accessoire</span>';
    //   } else {
    //     this.selectedAccessories.forEach(accessoryId => {
    //       const accessoryItem = this.container.querySelector(`[data-accessory-id="${accessoryId}"]`);
    //       if (accessoryItem) {
    //         const name = accessoryItem.dataset.accessoryTitle;
    //         const price = parseInt(accessoryItem.dataset.accessoryPrice);
    //         const item = document.createElement('span');
    //         item.className = 'accessories-selector__selected-item';
    //         item.textContent = `${name} (${price === 0 ? 'Gratuit' : this.formatMoney(price)})`;
    //         list.appendChild(item);
    //       }
    //     });
    //   }
    // }
  }

handleAccessorySelection(accessoryItem) {
  // 1. Find the parent container
  const container = accessoryItem.closest('[data-accessories-selector]');
  if (!container) return;

  // 2. Deselect all items inside this container
  container.querySelectorAll('.accessories-selector__item').forEach(item => {
    item.classList.remove('accessories-selector__item--selected');
  });

  // 3. Select clicked item
  accessoryItem.classList.add('accessories-selector__item--selected');

  // 4. Get the title from data-accessory-title attribute
  const title = accessoryItem.getAttribute('data-accessory-title') || '';

  // 5. Find the .sj-varaint-title element inside the parent container and update its text
  const titleElement = container.querySelector('.sj-variant-title');
  if (titleElement) {
    titleElement.textContent = title;
  }

  // Optional: store selection locally
  this.selectedAccessories = this.selectedAccessories || {};

  // 6. Call UI update functions if any
  if (typeof this.updateAccessoriesDisplay === 'function') this.updateAccessoriesDisplay();
  if (typeof this.updatePricing === 'function') this.updatePricing();
}





  updateAccessoryButtons() {
    // This method is no longer needed since we removed the select buttons
    // Accessories are now selected by clicking the item directly
  }

  updatePricing() {
    let totalPrice = 0;

    // Main product price
    const mainProductPrice = this.getMainProductPrice();
    totalPrice += mainProductPrice;


    // Saucer price
    if (this.selectedSaucer) {
      totalPrice += this.selectedSaucer.price;
    }

    // Accessories price
    if (!this.selectedAccessories.includes('none')) {
      this.selectedAccessories.forEach(accessoryId => {
        const accessoryItem = this.container.querySelector(`[data-accessory-id="${accessoryId}"]`);
        if (accessoryItem) {
          totalPrice += parseInt(accessoryItem.dataset.accessoryPrice);
        }
      });
    }

    // Update price displays
    this.updatePriceSummary(totalPrice);
    this.updateAddToCartButton(totalPrice);
    this.addSpaceAfterColons();
  }

  getMainProductPrice() {
    const select = this.container.querySelector('[data-product-select]');
    if (select && select.value) {
      const variants = JSON.parse(this.container.dataset.productVariants);
      const variant = variants.find(v => v.id == select.value);
      return variant ? variant.price : 0;
    }
    return 0;
  }

  updatePriceSummary(totalPrice) {
    // Update main product price
    const mainPrice = this.container.querySelector('[data-main-product-price]');
    if (mainPrice) {
      mainPrice.textContent = this.formatMoney(this.getMainProductPrice());
    }

    // Update accessories price
    const accessoriesItem = this.container.querySelector('.bundle-price-summary__item--accessories');
    const accessoriesPrice = this.container.querySelector('.bundle-price-summary [data-accessories-price]');
    if (accessoriesItem && accessoriesPrice) {
      let accessoriesTotal = 0;
      if (!this.selectedAccessories.includes('none')) {
        this.selectedAccessories.forEach(accessoryId => {
          const accessoryItem = this.container.querySelector(`[data-accessory-id="${accessoryId}"]`);
          if (accessoryItem) {
            accessoriesTotal += parseInt(accessoryItem.dataset.accessoryPrice);
          }
        });
      }
      
      // Only show accessories line if accessories are selected
      if (!this.selectedAccessories.includes('none') && this.selectedAccessories.length > 0) {
        accessoriesItem.style.display = 'flex';
        if (accessoriesTotal > 0) {
          accessoriesPrice.textContent = this.formatMoney(accessoriesTotal);
        } else {
          accessoriesPrice.textContent = 'Gratuit';
        }
      } else {
        accessoriesItem.style.display = 'none';
      }
    }

    // Update total price
    const totalPriceElement = this.container.querySelector('[data-total-price]');
    if (totalPriceElement) {
      totalPriceElement.textContent = this.formatMoney(totalPrice);
    }
  }

  updateAddToCartButton(totalPrice) {
    const button = this.container.querySelector('[data-bundle-add-to-cart-btn]');
    const priceElement = this.container.querySelector('[data-button-price]');
    
    if (priceElement && totalPrice !== undefined) {
      priceElement.textContent = this.formatMoney(totalPrice);
    }
  }

  async handleAddToCart(e) {
  e.preventDefault();
  e.stopPropagation();

  const button = e.target;
  const loadingState = this.container.querySelector('[data-loading-state]');
  const successState = this.container.querySelector('[data-success-state]');
  const errorState = this.container.querySelector('[data-error-state]');

  button.disabled = true;
  if (loadingState) loadingState.style.display = 'block';

  try {
    // Add products to cart
    const items = [];
    const select = this.container.querySelector('[data-product-select]');
    const pot = document.querySelector('.sj-accessories .accessories-selector__item--selected')?.getAttribute('data-accessory-id') || '';
    const accessory = document.querySelector('.sj-accessories1 .accessories-selector__item--selected')?.getAttribute('data-accessory-id') || '';
    const accessory1 = document.querySelector('.sj-accessories2 .accessories-selector__item--selected')?.getAttribute('data-accessory-id') || '';
    const saucer = document.querySelector('.sj-saucers .accessories-selector__item--selected')?.getAttribute('data-accessory-id') || '';

    var hide_price = 0;
    var unique = Math.random().toString(36).substring(7);
    if (document.body.classList.contains('sj-kit')) {
      hide_price = 1;
    }
    if(accessory1 != ""){
        items.push({
            id: parseInt(accessory1),
            quantity: 1,
            properties: {
                _bundle_id:parseInt(select.value),
                _role:'child',
                _hide_price: hide_price,
                _unique: unique
            }
        });
    }
    if(accessory != ""){
        items.push({
            id: parseInt(accessory),
            quantity: 1,
            properties: {
                _bundle_id:parseInt(select.value),
                _role:'child',
                _hide_price: hide_price,
                _unique: unique
            }
        });
    }
    if(saucer != ""){
        items.push({
            id: parseInt(saucer),
            quantity: 1,
            properties: {
                _bundle_id:parseInt(select.value),
                _role:'child',
                _hide_price: hide_price,
                _unique: unique
            }
        });
    }
    if(pot != ""){
        items.push({
            id: parseInt(pot),
            quantity: 1,
            properties: {
                _bundle_id:parseInt(select.value),
                _role:'child',
                _hide_price: hide_price,
                _unique: unique
            }
        });
    }
    
    if (select && select.value) {
      items.push({
        id: parseInt(select.value),
        quantity: 1,
        properties: {
            _bundle_id:parseInt(select.value),
            _role:'parent',
            _unique: unique
        }
      });
    } else {
      console.warn('No product select found or no value');
    }
    console.log('Final items to add to cart:', items);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (response.ok) {
      const result = await response.json();
      console.log('Successfully added to cart:', result);

      const form = this.container.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: result, addToCartBtn: button },
          bubbles: true
        }));
      }

      if (loadingState) loadingState.style.display = 'none';
      if (successState) successState.style.display = 'block';

      setTimeout(() => {
        if (successState) successState.style.display = 'none';
        button.disabled = false;
      }, 2000);
    } else {
      const errorData = await response.json();
      console.error('Cart API error response:', errorData);
      throw new Error(errorData.description || 'Failed to add items to cart');
    }

  } catch (error) {
    console.error('Error adding to cart:', error);

    if (loadingState) loadingState.style.display = 'none';
    if (errorState) {
      errorState.style.display = 'block';
      const errorMessage = errorState.querySelector('[data-error-message]');
      if (errorMessage) {
        errorMessage.textContent = 'Erreur lors de l\'ajout au panier. Veuillez réessayer.';
      }
    }

    setTimeout(() => {
      if (errorState) errorState.style.display = 'none';
      button.disabled = false;
    }, 3000);
  }
}


  navigateSlider(type, direction) {
    const slider = this.container.querySelector(`[data-${type}-slider]`);
    if (!slider) return;

    const itemWidth = 200; // Adjust based on your CSS
    const currentScroll = slider.scrollLeft;
    const scrollAmount = itemWidth * (direction === 'next' ? 1 : -1);
    
    slider.scrollTo({
      left: currentScroll + scrollAmount,
      behavior: 'smooth'
    });
  }

  formatMoney(cents) {
    // Format as "XX,XX €" to match the mockup
    const euros = (cents / 100).toFixed(2);
    return euros.replace('.', ',') + ' €';
  }

  // Ensure a space appears before every colon within this template only
  addSpaceAfterColons() {
    if (!this.container) return;
    const walker = document.createTreeWalker(this.container, NodeFilter.SHOW_TEXT, null);
    const toChange = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.nodeValue) continue;
      const original = node.nodeValue;
      // Ensure exactly one space before colon when missing
      const updated = original.replace(/(\S)\s*:(\S)/g, '$1 :$2');
      if (updated !== original) toChange.push({ node, updated });
    }
    toChange.forEach(({ node, updated }) => { node.nodeValue = updated; });
  }
  handleVariantChange(variant) {
    if (variant) {
      this.updatePricing();
      this.updateStandardPriceBlock(variant);
    }
  }

  updateStandardPriceBlock(variant) {
    if (!variant) {
      //console.log('updateStandardPriceBlock: variant not provided');
      return;
    }

    // Find the visible price block within product-blocks, not in hidden divs
    const productBlocks = this.container.querySelector('.product-blocks--new-pdp-v1') || this.container.querySelector('.product-blocks');
    if (!productBlocks) {
      //console.log('updateStandardPriceBlock: product-blocks not found');
      return;
    }

    // Find the price block that's not hidden
    const priceBlocks = productBlocks.querySelectorAll('.product-block--price');
    let priceBlock = null;
    for (let block of priceBlocks) {
      // Check if this block is visible (not in a hidden parent)
      let parent = block.parentElement;
      let isHidden = false;
      while (parent && parent !== document.body) {
        if (parent.style.display === 'none' || window.getComputedStyle(parent).display === 'none') {
          isHidden = true;
          break;
        }
        parent = parent.parentElement;
      }
      if (!isHidden) {
        priceBlock = block;
        break;
      }
    }

    // Fallback: just get the first price block in product-blocks
    if (!priceBlock && priceBlocks.length > 0) {
      priceBlock = priceBlocks[0];
    }

    if (!priceBlock) {
      //console.log('updateStandardPriceBlock: visible price block not found');
      return;
    }

    const priceElement = priceBlock.querySelector('[data-product-price][data-top-price]') || priceBlock.querySelector('[data-product-price]');
    const comparePriceElement = priceBlock.querySelector('[data-compare-price]');
    const priceWrapper = priceBlock.querySelector('[data-product-price-wrap]');
    const comparePriceA11y = priceBlock.querySelector('[data-compare-price-a11y]');
    const priceA11y = priceBlock.querySelector('[data-a11y-price]');

    if (!priceElement) {
      //console.log('updateStandardPriceBlock: priceElement not found in priceBlock', priceBlock);
      return;
    }

    //console.log('updateStandardPriceBlock: Updating price for variant', variant.id, 'Price:', variant.price, 'Compare:', variant.compare_at_price);

    // Update main price using theme's formatMoney if available, otherwise use our format
    const formatPrice = (cents) => {
      if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
        return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
      }
      return this.formatMoney(cents);
    };

    // Update main price
    const formattedPrice = formatPrice(variant.price);
    //console.log('updateStandardPriceBlock: Setting price to', formattedPrice);
    priceElement.textContent = formattedPrice;

    // Update compare price if it exists
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const formattedComparePrice = formatPrice(variant.compare_at_price);
      //console.log('updateStandardPriceBlock: Setting compare price to', formattedComparePrice);
      if (comparePriceElement) {
        comparePriceElement.textContent = formattedComparePrice;
      }
      if (priceWrapper) {
        priceWrapper.classList.remove('hide');
      }
      if (priceElement) {
        priceElement.classList.add('on-sale');
      }
      if (comparePriceA11y) {
        comparePriceA11y.setAttribute('aria-hidden', 'false');
      }
      if (priceA11y) {
        priceA11y.setAttribute('aria-hidden', 'false');
      }
    } else {
      // No compare price, hide compare price elements
      console.log('updateStandardPriceBlock: No compare price, hiding compare elements');
      if (priceWrapper) {
        priceWrapper.classList.add('hide');
      }
      if (priceElement) {
        priceElement.classList.remove('on-sale');
      }
      if (comparePriceA11y) {
        comparePriceA11y.setAttribute('aria-hidden', 'true');
      }
      if (priceA11y) {
        priceA11y.setAttribute('aria-hidden', 'true');
      }
    }
  }
}

// Initialize when DOM is ready or if it's already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    
    new ProductBundleNewPDPv1();
  });
} else {
  new ProductBundleNewPDPv1();
}
  document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('.size-selector__button--selected')){
        document.querySelector('.size-selector__button--selected').click();
    }
    else{
      const container = document.querySelector('.size-selector__buttons.sj-size-buttons');
      if (!container) return;

      const btn = container.querySelector(
        '.size-selector__button:not(.size-selector__button--disabled):not(.disabled):not([disabled])'
      );
      if (btn) {
        btn.click();
      }
    }
  });
function sj_select_first_item(){
    document.querySelectorAll('.sj-first-item').forEach(item => item.click());
}
// if any of accessory not available at all disable cart
function checkAccessoriesAvailability() {
    var selectors = document.querySelectorAll('.product-block--accessories-selector');
    var addToCartBtn = document.querySelector('button.btn.btn--full.add-to-cart');

    if (!selectors.length || !addToCartBtn) return;

    let shouldDisable = false;
    shouldDisable = [...selectors].some(selector => {
      const slides = selector.querySelectorAll('.swiper-slide.accessories-selector__item');

      return slides.length &&
        [...slides].every(slide => slide.classList.contains('disabled'));
    });

    // Select First Active Pot not disabled one
    var potColor = document.querySelector('.sj-saucers .accessories-selector__item--selected').dataset.saucerColor;
    var currentPot = document.querySelector('.sj-accessories .accessories-selector__item[data-pot-color="'+potColor+'"]');
        currentPot.classList.add('accessories-selector__item--selected');
    var potTitle = currentPot.dataset.accessoryTitle;
        document.querySelector('.sj-accessories .sj-variant-title').textContent = potTitle;
    if (shouldDisable) {
      addToCartBtn.classList.add('disabled');
      addToCartBtn.disabled = true;
      return false;
    } else {
      addToCartBtn.classList.remove('disabled');
      addToCartBtn.disabled = false;
      return true;
    }
    
}
// Sync Pot with saucer
function initializePotSaucerSync(){
      const potSlider = document.querySelector('.sj-accessories [data-accessories-swiper]');
      const saucerSlider = document.querySelector('.sj-saucers [data-accessories-swiper]');

      if (!potSlider || !saucerSlider) return;

      potSlider.addEventListener('click', (event) => {
          const potItem = event.target.closest('.accessories-selector__item');
          if (!potItem || potItem.classList.contains('disabled')) return;

          const potColor = potItem.dataset.potColor;
          if (!potColor) return;

          const targetSaucer = saucerSlider.querySelector(
              `.accessories-selector__item[data-saucer-color="${potColor}"]`
          );

          if (targetSaucer){
            saucerSlider.querySelectorAll('.accessories-selector__item').forEach(item => {
              item.classList.remove('accessories-selector__item--selected');
              item.classList.remove('sj-saucer-active');
            });
           saucerSlider.querySelector(
              `.accessories-selector__item[data-saucer-color="${potColor}"]`
           ).classList.add('sj-saucer-active');
           if(targetSaucer.classList.contains('disabled')){
              document.querySelector('button.btn.btn--full.add-to-cart').classList.add('sj-saucer-disabled');
            }
            else{
              targetSaucer.click();
              document.querySelector('button.btn.btn--full.add-to-cart').classList.remove('sj-saucer-disabled');
            }
          }
      });
  }
// Re-run automatically when dynamic content loads/changes
const observer = new MutationObserver(() => {
  //checkAccessoriesAvailability();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('variant:change', function(event) {
  // Run your accessory check each time variant changes
  setTimeout(function(){
    if(checkAccessoriesAvailability() == false){
      document.querySelector('button.size-selector__button.size-selector__button--selected').classList.add('disabled');
    }
  },1500);
});